import React from "react";
import { getLabel } from "../../language";
import { Modal } from "react-bootstrap";
import moment from "moment";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

const mapStateToProps = state => ({
    anonymousMode: state.user.anonymousMode
});

class SharePostModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAuthModalOpen: false,
            ActiveKey: "Facebook",
        };
    }

    componentWillMount() {
        let date = new Date();
        let commentDate = moment(date).format("YYYY-MM-DD")
        const { electionVoteDetails } = this.props
        if (this.props.polly) {
            const polly = this.props.polly || {};
            const faceBookMessage = `${getLabel(107)} ${polly.displayName} ${getLabel(108)} ${polly.facebookPage ? `https://www.facebook.com/${polly.facebookPage}` : ''} ${window.location.origin + '/vote/' + polly.urlSlug + '/' + this.props.userInfo.userName + '/' + commentDate}`
            const twitterMessage = `${getLabel(107)} ${polly.displayName} ${getLabel(108)} ${polly.twitter ? `@${polly.twitter}` : ''} ${window.location.origin + '/vote/' + polly.urlSlug + '/' + this.props.userInfo.userName + '/' + commentDate}`
            this.setState({
                faceBookMessage,
                twitterMessage
            })
        } else if (this.props.party) {
            const party = this.props.party || {};
            const faceBookMessage = `${getLabel(107)} ${party.name} ${getLabel(108)} ${party.facebookPage ? `https://www.facebook.com/${party.facebookPage}` : ''} ${window.location.origin + '/vote/' + party.urlSlug + '/' + this.props.userInfo.userName + '/' + commentDate}`
            const twitterMessage = `${getLabel(107)} ${party.name} ${getLabel(108)} ${party.twitter ? `@${party.twitter}` : ''} ${window.location.origin + '/vote/' + party.urlSlug + '/' + this.props.userInfo.userName + '/' + commentDate}`
            this.setState({
                faceBookMessage,
                twitterMessage
            })
        } else if (this.props.pollyVoteDetails) {
            const pollyVoteDetails = this.props.pollyVoteDetails || {};
            const faceBookMessage = `${getLabel(107)} ${this.props.pollyVoteDetails && this.props.pollyVoteDetails.displayName} ${getLabel(108)} ${pollyVoteDetails.facebookPage ? `https://www.facebook.com/${pollyVoteDetails.facebookPage}` : ''} ${window.location.href}`
            const twitterMessage = `${getLabel(107)} ${this.props.pollyVoteDetails && this.props.pollyVoteDetails.displayName} ${getLabel(108)} ${pollyVoteDetails.twitter ? `@${pollyVoteDetails.twitter}` : ''} ${window.location.href}`
            this.setState({
                faceBookMessage,
                twitterMessage
            })
        } else if (this.props.partyVoteDetails) {
            const party = this.props.party || {};
            const partyVoteDetails = this.props.partyVoteDetails || {};
            const faceBookMessage = `${getLabel(107)} ${partyVoteDetails.name} ${getLabel(108)} ${partyVoteDetails.facebookPage ? `https://www.facebook.com/${party.facebookPage}` : ''} ${window.location.href}`
            const twitterMessage = `${getLabel(107)} ${partyVoteDetails.name} ${getLabel(108)} ${partyVoteDetails.twitter ? `@${party.twitter}` : ''} ${window.location.href}`
            this.setState({
                faceBookMessage,
                twitterMessage
            })
        } else if (electionVoteDetails) {
            const electionVotes = electionVoteDetails || {};
            const faceBookMessage = `${getLabel(107)} ${electionVotes && electionVotes.electionType === "party" ? electionVotes.partyName : electionVotes.displayName} ${getLabel(108)} ${electionVotes.facebookPage ? `https://www.facebook.com/${electionVotes.facebookPage}` : ''} ${window.location.href}`
            const twitterMessage = `${getLabel(107)} ${electionVotes && electionVotes.electionType === "party" ? electionVotes.partyName : electionVotes.displayName} ${getLabel(108)} ${electionVotes.twitter ? `@${electionVotes.twitter}` : ''} ${window.location.href}`
            this.setState({
                faceBookMessage,
                twitterMessage
            })
        }
    }

    onComment = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        const { showShare, anonymousMode } = this.props;
        const { twitterMessage, faceBookMessage, ActiveKey } = this.state;
        return (
            <Modal show={showShare} container={this}>
                <div className={`modal-content ${anonymousMode ? "bgl" : ""}`}>
                    <div className="modal-header modal-header-sm share-modal bg-transparent">
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className={`mb-3 ${anonymousMode ? "cw" : ""}`}>Share Your Vote</h5>
                            </div>
                        </div>
                        <button className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" className="text-dark" onClick={this.props.onCloseShare}>×</span>
                        </button>
                    </div>
                    <div className={`aflexbox ${anonymousMode ? "dark" : ""}`}>
                        <ul className="nav nav-tabs">
                            <li className="nav-item" aria-expanded="false"
                                onClick={() => this.setState({ ActiveKey: "Facebook" })}>
                                <a href="#fb" className="nav-item active" data-toggle="tab" area-expanded="true" aria-expanded="true">
                                    {getLabel(98)}
                                </a>
                            </li>
                            <li className="nav-item" onClick={() => this.setState({ ActiveKey: "Twitter" })}>
                                <a href="#tweet" className="nav-item" data-toggle="tab" aria-expanded="false">
                                    {getLabel(99)}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="tab-content">
                                    <div className={`tab-pane ${ActiveKey === "Facebook" && "active"}`} id="fb">
                                        <textarea onChange={this.onComment} value={faceBookMessage} name="faceBookMessage" className={`form-control${anonymousMode ? "-dark" : ""} with-border share-modal-area`} />
                                        <div className="text-right mt-3">
                                            <a href={`http://www.facebook.com/sharer/sharer.php?u=https://www.politiq.net&quote=${faceBookMessage}`} target="_blank" className="btn btn-info fileuploader-input-button">
                                                <i className="fa fa-facebook bg-transparent" />{getLabel(98)}
                                            </a>
                                        </div>
                                    </div>
                                    <div className={`tab-pane ${ActiveKey === "Twitter" && "active"}`} id="tweet">
                                        <textarea onChange={this.onComment} value={twitterMessage} name="twitterMessage" className={`form-control${anonymousMode ? "-dark" : ""} with-border share-modal-area`} />
                                        <div className="text-right mt-3">
                                            <a href={`http://www.twitter.com/intent/tweet?text=${twitterMessage}`} target="_blank" className="btn btn-info fileuploader-input-button">
                                                <i className="fa fa-twitter bg-transparent" />{getLabel(99)}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
export default withRouter(connect(mapStateToProps)(SharePostModal));


